import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import { Trophy, Crown, Gem, X } from "lucide-react";

const ICON = { standard: Trophy, premium: Crown, exclusive: Gem };
const COLORS = ["#B7FF3C", "#FFFFFF", "#7CFF6B", "#1E7A3C"];

const burst = (tier) => {
  const power = { standard: 1, premium: 1.6, exclusive: 2.4 }[tier] || 1;
  confetti({ particleCount: Math.round(120 * power), spread: 90, startVelocity: 45, origin: { y: 0.6 }, colors: COLORS, zIndex: 9999 });
  const end = Date.now() + 900 * power;
  (function side() {
    confetti({ particleCount: 4, angle: 60, spread: 60, origin: { x: 0 }, colors: COLORS, zIndex: 9999 });
    confetti({ particleCount: 4, angle: 120, spread: 60, origin: { x: 1 }, colors: COLORS, zIndex: 9999 });
    if (Date.now() < end) requestAnimationFrame(side);
  })();
};

export const MilestoneCelebration = ({ memberNo, tiers }) => {
  const [tier, setTier] = useState(null);
  useEffect(() => {
    const key = `ca_celebrated_${memberNo}`;
    const seen = JSON.parse(localStorage.getItem(key) || "[]");
    const unlocked = tiers.filter((t) => t.unlocked).map((t) => t.key);
    const fresh = unlocked.filter((k) => !seen.includes(k));
    if (!fresh.length) return;
    localStorage.setItem(key, JSON.stringify(unlocked));
    const top = tiers.filter((t) => fresh.includes(t.key)).pop();
    setTier(top);
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) setTimeout(() => burst(top.key), 250);
  }, [memberNo, tiers]);

  if (!tier) return null;
  const I = ICON[tier.key];
  return (
    <div className="fixed inset-0 z-[9000] flex items-center justify-center px-5 bg-[#080A08]/75 backdrop-blur-sm" onClick={() => setTier(null)} data-testid="milestone-celebration">
      <div className="rise relative card-surface lime-glow border-[#B7FF3C]/50 max-w-md w-full p-9 text-center" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setTier(null)} className="absolute top-4 right-4 text-[#7C8A7C] hover:text-white" data-testid="celebration-close-btn" aria-label="Close"><X size={18} /></button>
        <div className="mx-auto w-20 h-20 rounded-full bg-[#B7FF3C]/10 border border-[#B7FF3C]/40 flex items-center justify-center floaty"><I size={38} className="text-[#B7FF3C]" /></div>
        <p className="eyebrow mt-6">Milestone unlocked</p>
        <h2 className="mt-2 text-4xl font-black uppercase" data-testid="celebration-tier-name">{tier.name} Reward!</h2>
        <p className="mt-3 text-[#C9D1C9]">You reached {tier.threshold} eligible referrals.</p>
        <p className="mt-1 text-white font-semibold" data-testid="celebration-reward">{tier.reward}</p>
        <p className="mt-3 text-xs text-[#7C8A7C]">Your reward is unlocked and held for redemption at launch.</p>
        <div className="mt-7 flex gap-3 justify-center">
          <button onClick={() => burst(tier.key)} className="px-5 py-2.5 rounded-full border border-[#2A362A] text-sm hover:border-[#B7FF3C]/60" data-testid="celebration-replay-btn">Celebrate again</button>
          <button onClick={() => setTier(null)} className="px-6 py-2.5 rounded-full bg-[#B7FF3C] text-[#080A08] font-bold text-sm hover:bg-[#c9ff6a]" data-testid="celebration-continue-btn">Continue</button>
        </div>
      </div>
    </div>
  );
};
